import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormlyConfig } from '../services/formly.config';
import { FormlyFieldConfig } from '../components/formly.field.config';
export class FormlyValidationMessage {
   fieldForm: FormControl;
   field: FormlyFieldConfig;
/**
 * @param {?} formlyConfig
 */
constructor(private formlyConfig: FormlyConfig) {}
/**
 * @return {?}
 */
get errorMessage(): string {
    for (let /** @type {?} */ error in this.fieldForm.errors) {
      if (this.fieldForm.errors.hasOwnProperty(error)) {
        let /** @type {?} */ message: string | Function = this.formlyConfig.getValidatorMessage(error);

        if (this.field.validation && this.field.validation.messages && this.field.validation.messages[error]) {
          message = this.field.validation.messages[error];
        }

        if (this.field.validators && this.field.validators[error] && this.field.validators[error].message) {
          message = this.field.validators[error].message;
        }

        if (this.field.asyncValidators && this.field.asyncValidators[error] && this.field.asyncValidators[error].message) {
          message = this.field.asyncValidators[error].message;
        }

        if (typeof message === 'function') {
          return message(this.fieldForm.errors[error], this.field);
        }

        return message;
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-validation-message',
  template: `{{ errorMessage }}`,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormlyConfig, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fieldForm': [{ type: Input },],
'field': [{ type: Input },],
};
}

function FormlyValidationMessage_tsickle_Closure_declarations() {
/** @type {?} */
FormlyValidationMessage.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyValidationMessage.ctorParameters;
/** @type {?} */
FormlyValidationMessage.propDecorators;
/** @type {?} */
FormlyValidationMessage.prototype.fieldForm;
/** @type {?} */
FormlyValidationMessage.prototype.field;
/** @type {?} */
FormlyValidationMessage.prototype.formlyConfig;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
